import { Injectable } from '@angular/core';
import { Utils } from 'src/app/utils/utilities';

@Injectable()
export class SelectOptionService {
  public dataGiftCard: any;
  public dataOptions: any;
  public dataSelected: any;
  public isValidData: any;
  public isValidCustomAmount: any;
  public isCustomAmount = false;

  constructor() {
    this.isValidData = true;
    this.isValidCustomAmount = true;
  }

  setDataSelectedCustomValue(data: any) {
    this.dataSelected = data;

    if (this.dataSelected === 'custom') {
      this.dataSelected = '';
    }
    this.dataSelected = this.dataSelected.toString().replace('$', '');
  }

  handleFocusInput(event: any) {
    const input = event.target;
    const inputParent = input.closest('.zip-row-input');

    inputParent.classList.add('is-inputed');
    inputParent.classList.add('is-focused');
  }

  handleBlurInput(event: any) {
    const input = event.target;
    const inputParent = input.closest('.zip-row-input');

    if (input.value === '') {
      inputParent.classList.remove('is-inputed');
    }
    inputParent.classList.remove('is-focused');
  }

  checkFieldsInput(inputs: any) {
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value === '') {
        inputs[i].closest('.zip-row-input').classList.remove('is-inputed');
      } else {
        inputs[i].closest('.zip-row-input').classList.add('is-inputed');
      }
    }
  }
}
